import {HighLowTransformer as Transformer} from './high-low-transformer'
import { FEATURES } from '..'
import usaLowZoom from './usa-low-zoom'

/*
 * Transforms from the earth view to the Albers USA
 */
export default class WorldUsaTransformer extends Transformer {

  static match (d0, d1) {
    if (!d0) {
      return false
    }

    let hasUsa = !![d0.node.key, d1.node.key].find(key => key == FEATURES.USA)
      , ids = [FEATURES.WORLD]

    return d0.node.key != d1.node.key
      && hasUsa // usa is coming or going
      && (
        // The other map is either north america or the world
        !!ids.find(id => id == d0.node.key) ||
        !!ids.find(id => id == d1.node.key)
      )
  }


  lowZoomed () {
    return usaLowZoom
  }

  /*
   * High resolution is always the usa
   */
  resolutions (enter, exit) {
    let high = enter.datum().node.key == FEATURES.USA ? enter : exit
      , low = enter.datum().node.key != FEATURES.USA ? enter : exit // opposite

    return {high, low}
  }

}
